// admin
export const adminList = '/Admin/Dashboards/AdminList'
export const adminInfo = '/Admin/Dashboards/AdminInfo'
export const editAdmin = '/Admin/Dashboards/EditAdmin'
export const AddAdmin = '/Admin/Dashboards/AddAdmin'
export const delAdmin = '/Admin/Dashboards/DelAdmin'
export const changePassword = '/Admin/Dashboards/ChangePassword'

// role
export const roleList = '/Admin/Dashboards/RoleList'
export const allRoleList = '/Admin/Dashboards/AllRoleList'
export const addRole = '/Admin/Dashboards/AddRole'
export const roleInfo = '/Admin/Dashboards/RoleInfo'
export const editRole = '/Admin/Dashboards/editRole'
export const delRole = '/Admin/Dashboards/delRole'
export const moduleMenus = '/Admin/Dashboards/ModuleMenus'

// module
export const moduleList = '/Admin/Dashboards/ModuleList'
export const addModule = '/Admin/Dashboards/AddModule'
export const moduleInfo = '/Admin/Dashboards/ModuleInfo'
export const editModule = '/Admin/Dashboards/EditModule'
export const delModule = '/Admin/Dashboards/DelModule'
export const allUnmountModules = '/Admin/Dashboards/AllUnmountModules'
export const mountModule = '/Admin/Dashboards/MountModule'
export const editModuleSort = '/Admin/Dashboards/EditModuleSort'
export const moduleTree = '/Admin/Dashboards/ModuleTree'

// subSystem
export const subSystemList = '/Admin/Dashboards/SubSystemList'
export const addSubSystem = '/Admin/Dashboards/AddSubSystem'
export const subSystemInfo = '/Admin/Dashboards/SubSystemInfo'
export const editSubSystem = '/Admin/Dashboards/EditSubSystem'
export const delSubSystem = '/Admin/Dashboards/DelSubSystem'
export const subSystemTree = '/Admin/Dashboards/SubSystemTree'
export const editSubSystemSort = '/Admin/Dashboards/EditSubSystemSort'

// permissions
export const savePermissions = '/Admin/Dashboards/SavePermissions'

// merchant
export const merchantList = '/Admin/Merchant/MerchantList'
export const addMerchant = '/Admin/Merchant/AddMerchant'
export const merchantInfo = '/Admin/Merchant/MerchantInfo'
export const editMerchant = '/Admin/Merchant/EditMerchant'
export const delMerchant = '/Admin/Merchant/DelMerchant'

// merchantAdmin
export const merchantAdminList = '/Admin/Merchant/MerchantAdminList'
export const addMerchantAdmin = '/Admin/Merchant/AddMerchantAdmin'
export const merchantAdminInfo = '/Admin/Merchant/MerchantAdminInfo'
export const editMerchantAdmin = '/Admin/Merchant/EditMerchantAdmin'
export const delMerchantAdmin = '/Admin/Merchant/DelMerchantAdmin'

// merchantBill
export const merchantBillList = '/Admin/Merchant/MerchantBillList'
export const merchantBillInfo = '/Admin/Merchant/MerchantBillInfo'

// MerchantRechargeOrder
export const merchantRechargeOrderList = '/Admin/Merchant/MerchantRechargeOrderList'
export const merchantRecharge = '/Admin/Merchant/MerchantRecharge'
export const merchantRechargeOrderInfo = '/Admin/Merchant/MerchantRechargeOrderInfo'



// WEBPACK FOOTER //
// ./src/api/index.js